// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { nullOrUndefined, string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogsCatalogIdDeleteResult = objectOf({
  catalogs: arrayOf(nullOrUndefined),
});

export const isAppsCatalogsCatalogIdFilteredSet = objectOf({
  id: string,
  name: string,
  description: string,
  created_at: anyOf(number, nullOrUndefined),
  updated_at: anyOf(number, nullOrUndefined),
  filters: arrayOf(
    objectOf({
      field: string,
      operator: string,
      value: string,
      type: string,
    })
  ),
  sort_field: anyOf(string, nullOrUndefined),
  sort_order: anyOf(boolean, nullOrUndefined),
  processing: boolean,
  results_limit: number,
  size: anyOf(number, nullOrUndefined),
  source: anyOf(string, nullOrUndefined),
});

export const isAppsCatalogsCatalogIdGetResult = objectOf({
  catalogs: arrayOf(
    objectOf({
      description: anyOf(string, nullOrUndefined),
      fields: arrayOf(
        objectOf({
          name: string,
          token: string,
          type: string,
        })
      ),
      name: string,
      num_items: number,
      storage_size: number,
      updated_at: string,
      created_at: string,
      id: string,
      import_errors: arrayOf(string),
      processing: boolean,
      update_error: objectOf({}),
      selections_size: anyOf(number, nullOrUndefined),
      source: string,
      back_in_stock_enabled: boolean,
      filtered_sets: arrayOf(isAppsCatalogsCatalogIdFilteredSet),
      notification_rate: nullOrUndefined,
      notification_period_rate: nullOrUndefined,
      price_drop_enabled: boolean,
      price_drop_operator: nullOrUndefined,
      price_drop_unit: nullOrUndefined,
      price_drop_value: nullOrUndefined,
      product_blocks_enabled: anyOf(boolean, nullOrUndefined),
      subscription_count: number,
    })
  ),
});
